import script from "./sim.vue?vue&type=script&setup=true&lang=js"
export * from "./sim.vue?vue&type=script&setup=true&lang=js"

import "./sim.vue?vue&type=style&index=0&id=e87db2ee&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e87db2ee"]])

export default __exports__